import React, { useEffect } from 'react';
import LayoutSvg from 'components/layout_and_quote_builder/quote_builder/LayoutSvg.jsx'
import QuoteBuilder from 'components/layout_and_quote_builder/quote_builder/QuoteBuilder.jsx'
import { Tooltip } from 'components/common';
import { PostRequest } from 'components/common/index.js';

const QuoteBuilderNavColumn = ({ index, config, item, options, multipleColumns, presentedOptions, setItems, navSection, colIndex, getExtraItems, selectedList, setSelectedList}) => {

  const QuoteBuilderEnabled = true;
  // /quote-builder/reset-nav-column/:user_quote_id/:item_uuid/:extra_item_reason
  const onDestruct = () => {
    if(item.is_item_extra) {
      PostRequest({
        url: `/quote-builder/reset-nav-column/${window.user_quote_id}/${item.uuid}/${item.extra_item_reason}`,
        data: {},
        callback: (data) => {
          // console.log({data})
        }
      })
    }
    console.log({
      onDestruct: 'onDestruct',
      item: item,
    })

  }

  useEffect(() => {
    return onDestruct;
  }, []);


  const extraItemReasonDescription = () => {
    return (
      <span className="float-right">
        <Tooltip title={t('quote_builder.extra_item_reason_' + item.extra_item_reason)} style="info" isSmall={true} hint={t('quote_builder.column_information')} />
      </span>
    );
  }

  const Svg = () => {
    if(item.klass == 'Drawing') {
      return; // we need a DrawingSvg component here
    }

    return <LayoutSvg
      index= {index}
      item={item}
      options={options}
      presentedOptions={presentedOptions}
      navSection={navSection}
      selectedList={selectedList}
      multipleColumns={multipleColumns}
      setSelectedList={setSelectedList}
    />
  }

  const columnTitle = () => {
    if(navSection.part_type == 'carton_lamination' || ['lamination_extra_item_one'].includes(item.extra_item_reason)) {
      return t('quote_builder.column_title_lamination');
    }

    return ""
  }

  const showColumnTitle = () => {
    if(columnTitle() != "") {
      return (
        <span className="float-right">
          <strong> {columnTitle()}  </strong>
        </span>
      )
    }

    return <br />;
  }


  const navSectionColumnType = () => {
    if(item.navSectionType != undefined) {
      return item.navSectionType;
    }
    return navSection.navSectionType;
  }

  const navSectionInfo = () => {
    return <small> [Kolon: {navSectionColumnType()}] </small>
  }

  return (<>
     {window.isAdmin && navSectionInfo() }

    <div className="quote_builder_container">

      {Svg()}

      {false && navSection.label != 'General' &&  navSection.label != 'Genel' && navSection.label != '' && navSection.label != undefined && (<div className="float-right">
        <h3> { navSection.label } </h3>
      </div>)}

      {showColumnTitle()}

      {item.extra_item_reason != undefined && extraItemReasonDescription() }

      {QuoteBuilderEnabled && <QuoteBuilder
        item={item}
        config={config}
        options={options}
        navSection={navSection}
        columnTitle={columnTitle()}
        colIndex={colIndex}
        getExtraItems={getExtraItems}
        navSectionColumnType={navSectionColumnType()}
      />}

    </div>
   </>)
}

export default QuoteBuilderNavColumn;
